<div class="col-12-nav">
    <div class="signin-header">
        <div class="container">
            <section class="logo center-block-wrap">
                <div class="logo-white"></div>
            </section>
        </div>
    </div>
    <div class="col-12 img-bg pl-5 pr-5">
        <div class="text-right mt-1">
            <a tabindex="0" id="en" class="btn btn-default border border-left-0 border-top-0 border-bottom-0 border-dark rounded-0" (click)="functionsService.useLanguage('en')">EN <span class="sr-only">Change language to English</span></a>
            <a tabindex="0" id="es" class="btn btn-default" (click)="functionsService.useLanguage('es')">ES <span class="sr-only">Cambiar idioma a español</span></a>
        </div>
<h3>{{ 'privacy_policy.title' | translate }}</h3>

<br><br>

<h5>General</h5>
<p>{{ 'privacy-policy.paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.paragraph3' | translate }}</p>
<p>{{ 'privacy-policy.paragraph4' | translate }}</p>
<p>{{ 'privacy-policy.paragraph5' | translate }}</p>

<h5>{{ 'privacy-policy.header-identification' | translate }}</h5>
<p>{{ 'privacy-policy.identification_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.identification_paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.identification_paragraph3' | translate }}</p>

<h5>{{ 'privacy-policy.header-payment' | translate }}</h5>
<p>{{ 'privacy-policy.payment_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.payment_paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.payment_paragraph3' | translate }}</p>

<h5>{{ 'privacy-policy.header-location' | translate }}</h5>
<p>{{ 'privacy-policy.location_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.location_paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.location_paragraph3' | translate }}</p>
<p>{{ 'privacy-policy.location_paragraph4' | translate }}</p>
<p>{{ 'privacy-policy.location_paragraph5' | translate }}</p>

<h5>{{ 'privacy-policy.header-use-info' | translate }}</h5>
<p>{{ 'privacy-policy.use_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.use_paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.use_paragraph3' | translate }}</p>
<p>{{ 'privacy-policy.use_paragraph4' | translate }}</p>
<p>{{ 'privacy-policy.use_paragraph5' | translate }}</p>

<h5>{{ 'privacy-policy.header-tenant-use' | translate }}</h5>
<p>{{ 'privacy-policy.tenant_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.tenant_paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.tenant_paragraph3' | translate }}</p>
<p>{{ 'privacy-policy.tenant_paragraph4' | translate }}</p>

<h5>{{ 'privacy-policy.header-tcpa' | translate }}</h5>
<p>{{ 'privacy-policy.tcpa_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.tcpa_paragraph2' | translate }}</p>
<ol type="a">
  <li>{{ 'privacy-policy.tcpa_list_a' | translate }}</li>
  <li>{{ 'privacy-policy.tcpa_list_b' | translate }}</li>
  <li>{{ 'privacy-policy.tcpa_list_c' | translate }}</li>
</ol>

<h5>{{ 'privacy-policy.header-cookies' | translate }}</h5>
<p>{{ 'privacy-policy.cookies_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.cookies_paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.cookies_paragraph3' | translate }}</p>

<h5>{{ 'privacy-policy.header-do-not-track' | translate }}</h5>
<p>{{ 'privacy-policy.dnt_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.dnt_paragraph2' | translate }}</p>

<h5>{{ 'privacy-policy.header-disclosure' | translate }}</h5>
<p>{{ 'privacy-policy.disclosure_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.disclosure_paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.disclosure_paragraph3' | translate }}</p>
<p>{{ 'privacy-policy.disclosure_paragraph4' | translate }}</p>

<h5>{{ 'privacy-policy.header-security' | translate }}</h5>
<p>{{ 'privacy-policy.security_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.security_paragraph2' | translate }}</p>

<h5>{{ 'privacy-policy.header-ccpa' | translate }}</h5>
<p>{{ 'privacy-policy.ccpa_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.ccpa_paragraph2' | translate }}</p>
<p>{{ 'privacy-policy.ccpa_paragraph3' | translate }}</p>

 <p>
    {{'privacy_policy.ccpa_info_4' | translate}}
</p>

<h5>{{"privacy_policy.privacy-policy-title8" | translate }}</h5>
<ul>
    <li>{{"privacy_policy.privacy-policy-section8-list4" | translate}}<br>{{"privacy_policy.privacy-policy-section8-list4-samplemessage" |translate}}</li>
    <li>{{"privacy_policy.privacy-policy-section8-list3" | translate}}</li>
    <li>{{"privacy_policy.privacy-policy-section8-list1" | translate}}</li>
    <li>{{"privacy_policy.privacy-policy-section8-list2" | translate}}<a [href]="termsConditionsUrl">{{ termsConditionsUrl }}</a></li><br>
</ul>


<h5>{{ 'privacy-policy.header-contact' | translate }}</h5>
<p>{{ 'privacy-policy.contact_paragraph1' | translate }}</p>
<p>{{ 'privacy-policy.contact_address' | translate }}</p>
<p>{{ 'privacy-policy.contact_phone' | translate }}</p>
<p>{{ 'privacy-policy.contact_email' | translate }}</p>
        <div class="p-4 text-center small">©2025 Alertia. {{'general.all_rights' | translate}} - Version 1.2.0</div>
    </div>
</div>
